import Link from 'next/link'
import styled from 'styled-components'
import Stack from '@careguide/stack'
import { Subheading } from '@careguide/typography'
import css from '@styled-system/css'

import BackArrowMobile from 'Images/SVG/BackArrowMobile.svg'

type BackButtonProps = {
  label: string
  link: string
}

export const BackButton = styled(({ label, link, ...props }: BackButtonProps) => {
  return (
    <Link passHref={true} href={link} prefetch={true}>
      <a {...props}>
        <Stack as='a' valign='center' direction='horizontal' gap='2'>
          {/* TODO align */}
          <img role='presentation' src={BackArrowMobile} width='16px' height='13px' />
          <StyledSubheading size='2'>{label}</StyledSubheading>
        </Stack>
      </a>
    </Link>
  )
})`
  width: 100%;
  text-decoration: none;
`

const BackButtonMobile = styled(BackButton)`
  ${css({
    display: ['block', undefined, 'none'],
  })}
`

// TODO: Fix alignment in design system
const StyledSubheading = styled(Subheading)`
  padding-top: 2px;
`

export default BackButtonMobile
